// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Interventions_wrapper__1jIfm","no-interventions":"Interventions_no-interventions__2EbLA","intervention-form-container":"Interventions_intervention-form-container__3jkGR"};